import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import LoginForm from './components/LoginForm';

export default function Login() {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #0F172A 0%, #1E3A5F 50%, #1E40AF 100%)',
      }}
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute -top-40 -right-40 rounded-full opacity-10"
          style={{ width: 600, height: 600, background: 'radial-gradient(circle, #3B82F6, transparent)' }}
        />
        <div
          className="absolute -bottom-40 -left-40 rounded-full opacity-10"
          style={{ width: 500, height: 500, background: 'radial-gradient(circle, #1E40AF, transparent)' }}
        />
      </div>
      <div className="relative w-full max-w-md">
        {/* Card */}
        <div
          className="rounded-2xl p-8"
          style={{
            background: 'var(--color-card)',
            boxShadow: '0 24px 48px rgba(0,0,0,0.3)',
          }}
        >
          {/* Logo + Brand */}
          <div className="flex flex-col items-center mb-8">
            <div
              className="flex items-center justify-center rounded-2xl mb-4"
              style={{
                width: 56,
                height: 56,
                background: 'var(--color-primary)',
                boxShadow: '0 8px 24px rgba(30,64,175,0.4)',
              }}
            >
              <Icon name="BarChart3" size={28} color="#FFFFFF" strokeWidth={2} />
            </div>
            <h1
              className="font-heading font-bold text-2xl"
              style={{ color: 'var(--color-foreground)', letterSpacing: '-0.02em' }}
            >
              CRM<span style={{ color: 'var(--color-primary)' }}>Analytics</span>
            </h1>
            <p className="font-caption text-sm mt-1 text-center" style={{ color: 'var(--color-text-secondary)' }}>
              Sign in to your analytics dashboard
            </p>
          </div>

          {/* Security badge */}
          <div
            className="flex items-center justify-center gap-2 px-3 py-2 rounded-lg mb-6"
            style={{ background: '#ECFDF5', border: '1px solid #A7F3D0' }}
          >
            <Icon name="Shield" size={14} color="#059669" />
            <span className="font-caption text-xs font-medium" style={{ color: '#059669' }}>
              256-bit SSL encrypted
            </span>
          </div>

          {/* Login Form */}
          <LoginForm />

          {/* Sign up link */}
          <p className="text-center font-caption text-sm mt-6" style={{ color: 'var(--color-text-secondary)' }}>
            Don't have an account?{' '}
            <Link
              to="/signup"
              className="font-semibold transition-colors hover:underline"
              style={{ color: 'var(--color-primary)' }}
            >
              Create account
            </Link>
          </p>
        </div>

        {/* Footer links */}
        <div className="flex items-center justify-center gap-4 mt-6">
          <span className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>
            Protected by 256-bit SSL encryption
          </span>
        </div>
      </div>
    </div>
  );
}
